<template>
  <div class="d-flex gap-2 flex-wrap">
    <button v-if="peutReleve" class="btn btn-outline-secondary" :disabled="enCours" title="Copie de toutes les données du patient, à lui remettre s'il la demande (droit d'accès)" @click="releve">
      <i class="bi bi-file-earmark-person me-1"></i>{{ enCours ? 'Préparation…' : 'Relevé des données' }}
    </button>
    <button v-if="peutAcces" class="btn btn-outline-secondary" @click="ouvrirAcces">
      <i class="bi bi-eye me-1"></i>Accès au dossier
    </button>

    <div v-if="acces" class="modal-backdrop-custom" @click.self="acces = null">
      <div class="modal-card card shadow">
        <div class="card-header d-flex justify-content-between">
          <h5 class="mb-0">Qui a consulté ou modifié ce dossier</h5>
          <button class="btn-close" @click="acces = null"></button>
        </div>
        <div class="card-body">
          <div v-if="!acces.length" class="text-muted">Aucun accès enregistré.</div>
          <div v-else class="table-responsive">
            <table class="table table-sm align-middle">
              <thead><tr><th>Date</th><th>Personne</th><th>Action</th><th>Poste (IP)</th></tr></thead>
              <tbody>
                <tr v-for="(a, i) in acces" :key="i">
                  <td class="text-nowrap small">{{ dateHeure(a.date) }}</td>
                  <td>{{ a.utilisateur }}</td>
                  <td class="small">{{ a.description }}</td>
                  <td class="small text-muted">{{ a.ip || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <small class="text-muted">Chaque ouverture du dossier est enregistrée (au plus une fois par demi-heure et par personne), ainsi que les modifications et les relevés édités.</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api, { messageErreur, notifier } from '@/api'

/** Droits du patient sur ses données : relevé (droit d'accès) et traçabilité des accès. */
export default {
  name: 'DonneesPatient',
  props: { patient: { type: Object, required: true } },
  data() {
    return { acces: null, enCours: false }
  },
  computed: {
    peutReleve() { return this.$store.getters.hasPermission('PATIENT_RELEVE_DONNEES') },
    peutAcces() { return this.$store.getters.hasPermission('ADMIN_JOURNAL_AUDIT') },
  },
  methods: {
    async releve() {
      this.enCours = true
      try {
        await api.telecharger(`patients/${this.patient.id}/releve-donnees`, `releve-donnees-${this.patient.numeroDossier || this.patient.id}.pdf`, true)
      } catch (e) {
        if (e?.response?.status !== 403) notifier(messageErreur(e, "Le relevé n'a pas pu être édité."))
      } finally {
        this.enCours = false
      }
    },
    async ouvrirAcces() {
      try {
        this.acces = (await api.custom(`patients/${this.patient.id}/acces`, 'GET')).data.data
      } catch (e) {
        if (e?.response?.status !== 403) notifier(messageErreur(e))
      }
    },
    dateHeure(d) {
      const x = new Date(d)
      return x.toLocaleDateString('fr-FR') + ' ' + x.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    },
  },
}
</script>

<style scoped>
.modal-backdrop-custom { position: fixed; inset: 0; background: rgba(0, 0, 0, .45); z-index: 1050; display: flex; align-items: flex-start; justify-content: center; padding: 30px 16px; overflow-y: auto; }
.modal-card { width: 100%; max-width: 860px; border-radius: 12px; }
</style>
